import { n, s as safeDefineFsComponent } from './query-assigned-elements.js';
import './index2.js';
import { i, s, x } from './lit-element.js';

var typographyHostStyles = i`:host{font-family:var(--fs-font-stack,Optimist,"Helvetica Neue",Helvetica,Arial,sans-serif);margin:var(--fs-size-spacing-none,0);display:block}:host([size="tiny"]){color:var(--fs-text-color-primary,hsl(0,0%,8%));font-size:var(--fs-font-heading-tiny,0.75rem);font-weight:var(--fs-font-weight-semibold,600);line-height:var(--fs-font-line-height-normal,1.5)}:host([size="small"]){color:var(--fs-text-color-primary,hsl(0,0%,8%));font-size:var(--fs-font-heading-small,0.875rem);font-weight:var(--fs-font-weight-semibold,600);line-height:var(--fs-font-line-height-normal,1.5)}:host([size="normal"]){color:var(--fs-text-color-primary,hsl(0,0%,8%));font-size:var(--fs-font-heading-normal,1rem);font-weight:var(--fs-font-weight-semibold,600);line-height:var(--fs-font-line-height-normal,1.5)}:host([size="medium"]){color:var(--fs-text-color-primary,hsl(0,0%,8%));font-size:var(--fs-font-heading-medium,1.25rem);font-weight:var(--fs-font-weight-semibold,600);line-height:var(--fs-font-line-height-normal,1.5)}:host([size="large"]){color:var(--fs-text-color-primary,hsl(0,0%,8%));font-size:var(--fs-font-heading-large,2rem);font-weight:var(--fs-font-weight-light,300);line-height:var(--fs-font-line-height-small,1.3)}:host([size="xlarge"]){color:var(--fs-text-color-primary,hsl(0,0%,8%));font-size:var(--fs-font-heading-xlarge,3rem);font-weight:var(--fs-font-weight-extra-light,100);line-height:var(--fs-font-line-height-small,1.3)}:host([size="xxlarge"]){color:var(--fs-text-color-primary,hsl(0,0%,8%));font-size:var(--fs-font-heading-xxlarge,4rem);font-weight:var(--fs-font-weight-extra-light,100);line-height:var(--fs-font-line-height-tiny,1.2)}:host([variant="secondary"]){color:var(--fs-text-color-secondary,hsl(0,0%,41%))}:host([variant="inverse"]){color:var(--fs-text-color-inverse,hsl(0,0%,100%));color:var(--fs-text-color-inverse,hsl(0,0%,100%))}`;

var __decorate = (undefined && undefined.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __classPrivateFieldGet = (undefined && undefined.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _FsHeading_internals;
/**
 * The web component implementation of the Financial Services heading component
 *
 * ## Installation
 *
 * ```bash
 * npm i @cof/fs-typography-wc
 * ```
 *
 * ## Usage
 *
 * To import the side-effectful registration of `<fs-heading>` call
 *
 * ```javascript
 * import '@cof/fs-typography-wc/fs-heading.js';
 * ```
 *
 * To import the `FsHeading` class as either a base class or to self-register the custom element use
 *
 * ```javascript
 * import { FsHeading } from '@cof/fs-typography-wc';
 * ```
 *
 * ## Example
 *
 * ```html
 * <fs-heading level="1" size="large">Hello world</fs-heading>
 * ```
 *
 * @element fs-heading
 * @slot - The heading text
 */
class FsHeading extends s {
    constructor() {
        super();
        /** Contains APIs for working with the accessibility object model */
        _FsHeading_internals.set(this, this.attachInternals());
        /**
         * The relative heading level this element represents
         * @attribute level
         */
        this.level = 1;
        /**
         * Adjust the size and styles of the heading element within the context
         * of the FS Design System
         * @attribute size
         */
        this.size = 'medium';
        /**
         * The heading component's priority or display value
         * @attribute variant
         */
        this.variant = 'primary';
        /** Make sure this element will have a default role */
        __classPrivateFieldGet(this, _FsHeading_internals, "f").role = 'heading';
    }
    /** When the level changes, update the internals aria-level */
    updated(changed) {
        if (changed.has('level')) {
            __classPrivateFieldGet(this, _FsHeading_internals, "f").ariaLevel = this.level.toString();
        }
    }
    render() {
        return x `<slot></slot>`;
    }
}
_FsHeading_internals = new WeakMap();
FsHeading.styles = [typographyHostStyles];
/** Set the elemnent's canonical name */
FsHeading.canonicalName = 'heading';
__decorate([
    n({ type: Number, reflect: true })
], FsHeading.prototype, "level", void 0);
__decorate([
    n()
], FsHeading.prototype, "size", void 0);
__decorate([
    n()
], FsHeading.prototype, "variant", void 0);

safeDefineFsComponent.define(FsHeading);
